import * as _ from "lodash"
import {Metric} from "@/cube"

export function keyedDataUpdate<T extends {[key in Metric]: string | number}>(
  metric: Metric,
  toKey: (row: T) => string,
  source: ReadonlyArray<T>,
  target: Array<T>
): void {
  const sourceByKey = _.keyBy(source, toKey)
  target.forEach(row => {
    const key = toKey(row)
    const sourceEntry = <any | null>sourceByKey[key]
    row[metric] = sourceEntry == null ? 0 : sourceEntry[metric]
  })
}
